/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-03-20T09:07:50-07:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-05-31T10:32:12-07:00
*/



import React, { Component } from 'react';
import Text from '../../common/Text';
import _ from 'lodash';

class AboutMe extends Component {



  render() {
    return (
      <span>
        <div className="essay">
          <h3 className="essay-title title-size4">
            A little bit about myself
          </h3>
          <Text whiteSpace='preLine'>
            {this.props.description}
          </Text>
        </div>
      </span>

    );
  }
}

export default AboutMe;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/AboutMe.jsx